import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/astronaut-riding-rocket-waving-hand.svg";
import TrackVisibility from 'react-on-screen';
import  {TypeAnimation}  from 'react-type-animation';


export const Banner = () => {
 
  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={6}>
          
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                
                <h1>{`Hello! I'm Mayura`}</h1>

                <div className="type-animation">
                  <TypeAnimation
                  sequence={[
                    'Web Developer',
                    1000,
                    'UI/UX Designer',
                    1000,
                    'Mobile App Developer',
                    1000
                  ]}
                  wrapper="span"
                  speed={20}
                  cursor={false}
                  repeat={Infinity}
                  />
                  <span className="typer-cursor">|</span>
                  </div>

                  <p className="banner-desc">Passionate Web and Mobile App Developer, dedicated to creating cutting-edge solutions that anticipate and address the evolving needs of the digital world. Let's launch your vision into the future! 🚀</p>            
                  <button ><span><a href="#contact">Contact Now</a></span></button>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
